module.exports = __webpack_public_path__ + "img/4-m.d610b91c.jpg";